import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_NEW_COACHES} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {NewGen0CoachesContent} from './NewGen0CoachesContent';
import reportPayload from './reportPayload';

export const NewGen0CoachesReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      // @ts-expect-error TS(2322): Type '{ title: any; description: any; contentProps... Remove this comment to see the full error message
      title={tt('title', 'New Generation 0 Coaches')}
      description={tt(
        'description',
        "New Coaches you've sponsored, or Coaches sponsored by Coaches on your team, this month.",
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={NewGen0CoachesContent}
    />
  );
};

export default withHOC(
  withTranslation('report.newGen0Coaches'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_NEW_COACHES,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts(
          'reportRecordTitle.newGen0Coaches',
          'New Generation 0 Coaches',
        ),
    },
  }),
)(NewGen0CoachesReport);
